import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import range from 'lodash/range';
import round from 'lodash/round';
import s from '../../../../../redux/selectors';
import { wrap, withT } from '../../../../../lib/wrappers';

import types from '../../../../../types';
import InlineInput from '../InlineInput';
import InlineSelect from '../InlineSelect';

const percentOptions = range(0.05, 1.05, 0.05).map(value => ({
  value: round(value, 2),
  display: `${round(value * 100)}%`,
}));

const InstallHotWaterHeater = ({
  t,
  isMetric,
  inputFootprintHousingSquarefeet,
}) => (
  <div className="action-details">
    <div className="action-details__form">
      <p>
        <span
          // eslint-disable-next-line react/no-danger
          dangerouslySetInnerHTML={{
            __html: t('A typical {{inputFootprintHousingSquarefeet}} {{areaUnits}}<sup>2</sup> home in my climate uses', {
              inputFootprintHousingSquarefeet: inputFootprintHousingSquarefeet.ensuredDisplay,
              areaUnits: isMetric ? t('m', { ns: 'units' }) : t('ft', { ns: 'units' }),
            }),
          }}
        />
        <InlineInput
          maxLength={5}
          apiKey={'input_takeaction_install_solar_heating_ng_consumption'}
        />
        <span
          // eslint-disable-next-line react/no-danger
          dangerouslySetInnerHTML={{
            __html: t('{{volumeUnit}}<sup>3</sup> per year on natural gas heating.', {
              volumeUnit: isMetric ? t('m', { ns: 'units' }) : t('ft', { ns: 'units' }),
            }),
          }}
        />
      </p>
      <p>
        {t('I will meet')}
        <InlineSelect
          options={percentOptions}
          apiKey={'input_takeaction_install_solar_heating_percent'}
        />
        {t('of my water heating needs by installing a solar water heater. It costs')}
        <InlineInput
          currency
          maxLength={5}
          apiKey={'input_takeaction_install_solar_heating_cost'}
        />
        <span
          // eslint-disable-next-line react/no-danger
          dangerouslySetInnerHTML={{
            __html: t('per {{volumeUnits}}<sup>3</sup> of natural gas.', {
              volumeUnits: isMetric ? t('m', { ns: 'units' }) : t('ft', { ns: 'units' }),
            }),
          }}
        />
      </p>
    </div>
    <div className="action-details__links">
      <a
        href="http://www.coolcalifornia.org/funding-wizard#search/home+electricity//false/none/false/1/12"
        target="_blank"
        rel="noopener noreferrer"
      >{t('Find rebates and incentives for this action')}</a>
    </div>
  </div>
);

InstallHotWaterHeater.propTypes = {
  // wrapped
  t: PropTypes.func.isRequired,
  // connected props
  isMetric: PropTypes.bool.isRequired,
  inputFootprintHousingSquarefeet: types.UserInput.isRequired,
};

const mapStateToProps = (state, ownProps) => [
  'isMetric',
  'inputFootprintHousingSquarefeet',
].reduce((props, selector) => ({
  ...props,
  [selector]: s[selector](state, ownProps),
}), {});

const mapDispatchToProps = () => ({});

export default wrap(
  withT('installSolarHeating'),
  connect(mapStateToProps, mapDispatchToProps)(InstallHotWaterHeater),
);
